import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

import { IUseRouterGlobalSearchSearchQuery } from 'src/hooks/router/useGlobalSearch'

const inputSchema = z.object({
  searchQuery: z.string().describe('Search query string to find CRM objects'),
}) as any

const outputSchema = z.object({
  success: z.boolean(),
  message: z.string(),
}) as any

export const globalSearchTool = createTool({
  id: 'global-search',
  description:
    'Perform a global search across all CRM objects. Use this when user wants to find contacts, deals, companies, or any other records by name, email, phone, or other criteria.',
  inputSchema,
  outputSchema,
  execute: async (context) => {
    const { searchQuery } = context

    const querySearch: IUseRouterGlobalSearchSearchQuery = {
      modal: 'global-search',
      globalSearch: searchQuery,
    }
    store.dispatch(
      appActions.navigate({
        search: querySearch,
      })
    )

    return {
      success: true,
      message: `Searching for: ${searchQuery}`,
    }
  },
})
